import $ from 'jquery';
import Lazy from 'jquery-lazy/jquery.lazy';

export default class Paginator {

    constructor(selector) {
        $(selector).each((e, el) => {
            el = $(el);
            if (!this.isValidUrl(el.attr('data-paginator'))) {
                return;
            }
            $(window).on('scroll', (e) => {
                // let canFetch = ($(window).scrollTop() + $(window).innerHeight() + 1300) > el[0].scrollHeight;
                let canFetch = ($(window).scrollTop() + $(window).innerHeight()) > (el.offset().top + el.outerHeight() - ($(window).innerHeight()/1.2));
                if (canFetch) {
                    this.fetchNewContent(el)
                }
            })
        });
    }

    fetchNewContent(element) {
        if (!element.data('next')) {
            element.data('next', parseInt(element.attr('data-page-next'), 10))
        }
        if (!element.data('total')) {
            element.data('total', parseInt(element.attr('data-page-total'), 10))
        }

        if (element.data('fetching') === true || element.data('next') > element.data('total')) {
            return;
        }

        element.data('fetching', true);

        $.ajax({
            type: 'get',
            url: element.attr('data-paginator'),
            data: {
                page: element.data('next'),
                json: 1
            },
            dataType: "json",
            beforeSend: function () {
                element.find('.list-grid-spinner').stop().fadeIn('fast');
            },
            success: function (response) {
                let html = $(response.html);
                if (typeof window[element.data('success-callback')] === 'function') {
                    window[element.data('success-callback')]($, element, html);
                } else {
                    element.append(html);
                }

                element.data('fetching', false);
                element.data('next', parseInt(element.data('next'), 10) + 1);

                $('.lazy').Lazy({
                    afterLoad: function (element) {
                        $(element).addClass('lazy--loaded');
                        $(element).parents('.has-lazy')
                            .show('fast')
                            .css('padding', 0)
                            .removeClass('spinner')
                            .removeClass('has-lazy');

                        let _root = $(element).parents('.default-item__media');
                        if (_root.length && _root.find('.default-item__image__desc').length) {
                            _root.find('.default-item__image').css({
                                width: _root.find('.default-item__image img').css('width')
                            })
                        }
                    },
                });


            },
            complete: function () {
                element.find('.list-grid-spinner').stop().fadeOut('fast');
            },
            error: function () {

            }
        });
    }

    isValidUrl(url) {
        var regexp = /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/
        return regexp.test(url);
    }

    updateQueryStringParameter(uri, key, value) {
        var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
        var separator = uri.indexOf('?') !== -1 ? "&" : "?";
        if (uri.match(re)) {
            return uri.replace(re, '$1' + key + "=" + value + '$2');
        } else {
            return uri + separator + key + "=" + value;
        }
    }


}



// WEBPACK FOOTER //
// ./src/scripts/Paginator.js